<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-11 18:28:29
 * @LastEditTime: 2021-01-21 10:30:33
-->
<template>
  <div
    class="user-item"
    @click="changeUser(source)"
    :class="{ active_li: source.i == curUser }"
  >
    <div class="avatar">
      <img src="../../assets/img/kehu_list.png" alt="" />
    </div>
    <div class="center">
      <div class="name">{{ source.u_n }}</div>
      <div class="news">{{ getMsgType(source.msg) }}</div>
    </div>
    <div class="hasNews" v-if="source.un_r_c">{{ source.un_r_c }}</div>
    <!-- <div class="close">
      <i class="el-icon-close"></i>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "item-component",
  props: {
    index: {
      type: Number,
    },
    source: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    curUser() {
      return this.$store.state.app.curUser;
    },
  },
  methods: {
    changeUser(source) {
      this.$store.dispatch("app/changeUser", source.i);
      localStorage.setItem("curUser", source.i);
    },
    getMsgType(val) {
      if (val.indexOf("fl@:") !== -1) {
        return "文件";
      } else if (val.indexOf("il@:") !== -1) {
        return "图片";
      } else {
        return val;
      }
    },
  },
  mounted() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
};
</script>

<style scoped lang="scss">
.user-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  position: relative;
  cursor: pointer;
  .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #779fb3;
    img {
      width: 60%;
      height: 60%;
    }
  }
  .center {
    margin-left: 20px;
    flex: 1;
    overflow: hidden;
    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 15px;
      color: #333333;
      margin-bottom: 10px;
    }
    .news {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      color: #8d8d8d;
    }
  }
  .hasNews {
    // margin-right: 10px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    line-height: 16px;
    background: #d92f2f;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    opacity: 0;
    transition: all 0.3s linear;
    font-size: 20px;
    color: #333333;
  }
  .close:hover{
    opacity: 1;
  }
}
.active_li {
  background: #bac5d6 !important;
}
</style>